import { useEffect, useState } from "react";
import { toast } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import jwtDecode from "jwt-decode";
import { calculatePaymentScore, clearPaymentData } from "../../helper/common";
import SkorDefaultLoader from "../../assets/img/skorDefaultLoader.gif";

const ExtTinkVerification = () => {
  const { _t } = useTranslator();
  const queryParameters = new URLSearchParams(window.location.search);

  const account_verification_report_id = queryParameters.get(
    "account_verification_report_id",
  );
  const transaction_report_id = queryParameters.get("transaction_report_id");
  const userTokenParam = queryParameters.get("userToken");

  const [tinkSuccess, setTinkSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (
      !userTokenParam ||
      !account_verification_report_id ||
      !transaction_report_id
    ) {
      toast.error("Invalid or missing parameters");
      setLoading(false);
      return;
    }

    try {
      jwtDecode(userTokenParam);
    } catch (error) {
      toast.error("Failed to process request");
      setLoading(false);
      window.parent.postMessage("BANK_FAILURE", "*");
      return;
    }

    calculateScore(
      userTokenParam,
      account_verification_report_id,
      transaction_report_id,
    );
  }, []);

  const calculateScore = async (
    token,
    accountverificationid,
    transactionreportid,
  ) => {
    try {
      await clearPaymentData(token);
      await calculatePaymentScore(
        token,
        accountverificationid,
        transactionreportid,
      );

      setTinkSuccess(true);
      window.parent.postMessage("BANK_SUCCESS", "*");
    } catch (err) {
      toast.error("Failed to calculate score");
      window.parent.postMessage("BANK_FAILURE", "*");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{ height: "100vh" }}
      className="dgboxsetup authenticateModal dgboxsetup2"
    >
      <div className="defaultSkorLoaderParent">
        {loading ? (
          <img
            src={SkorDefaultLoader}
            className="defaultSkorLoader"
            alt="Loading"
          />
        ) : tinkSuccess ? (
          <div>Tink Success</div>
        ) : (
          <div>Something went wrong</div>
        )}
      </div>
    </div>
  );
};

export default ExtTinkVerification;
